import { create } from 'zustand'
import { NavigationStoreType } from './stores.types';

const useNavigationStore = create<NavigationStoreType>((set) => ({
    // section.number 0 = BeforeStart
    // section.number = 1 = FirstSection // block : EmailCheck, Register
    // section.number = 2 = SecondSection // block : USPerson, LegalAgentSituation, FinancialJob, HomeAddress, FiscalAddress, Birth, LegalCapacity, Nationality
    // section.number = 3 = ThirdSection // block : CompanyMisc, SirenNumber, CompanyInformations, Various, Beneficiaries, BeneficiariesInformations, 
    // section.number = 4 = FourthSection // block : LCBFT, LatestResults, Informations
    // section.number = 5 = FifthSection // block : AccountInformations, AccountOptions, PriceList, FundsOrigin, Iban
    // section.number = 6 = SixthSection // block : Documents, Identity, ProofOfAddress, BeneficiariesDocuments, CompanyDocuments, Overview, Signature
    // section.number = 7 = SeventhSection // block : Finish, UploadMissingDocs

    section: {
        number: 0,
        block: 'BeforeStart',
    },

    setSection: (sectionNumber: number) => set((state) => ({
        section: {
            ...state.section,
            number: sectionNumber
        }
    })),
    setBlock: (block: string) => set((state) => ({
        section: {
            ...state.section,
            block: block
        }
    })),
}))

export default useNavigationStore;
